import { useEffect, useState } from 'react';
import { api } from '../api/client';
import { useAuth } from '../auth/AuthContext';
import { CategoryCard } from '../components/CategoryCard';
import type { Category } from '../types';

export function DashboardPage() {
  const { user } = useAuth();
  const [categories, setCategories] = useState<Category[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    api<Category[]>('/api/categories')
      .then((data) => { if (!cancelled) setCategories(data); })
      .catch((err) => { if (!cancelled) setError(err instanceof Error ? err.message : 'Failed to load categories'); });
    return () => { cancelled = true; };
  }, []);

  return (
    <div className="page-content">
      <header className="dashboard-header">
        <h1>Welcome{user?.name ? `, ${user.name}` : ''}</h1>
        <p>Pick a situation to practise.</p>
      </header>

      {error && <div className="form-error" role="alert">{error}</div>}
      {!categories && !error && (<p style={{ color: 'var(--text-muted)' }}>Loading categories…</p>)}
      {categories && categories.length === 0 && (<p style={{ color: 'var(--text-muted)' }}>No categories yet.</p>)}

      {categories && categories.length > 0 && (
        <div className="category-grid">
          {categories.map((c) => (<CategoryCard key={c.id} category={c} />))}
        </div>
      )}
    </div>
  );
}
